import { fills } from "theme/fills";

export function baseAttrs(): Record<string, string> {
  return {
    animation: "shine-avatar 1.6s infinite linear"
  };
}

export function backgroundAttrs(
  loading = true,
  fillColor = fills.default
): Record<string, string> {
  const defaultFill = fills.default;
  const contrastFill = fills.contrast;
  return {
    backgroundColor: loading ? defaultFill : fillColor,
    backgroundImage: loading
      ? `linear-gradient(90deg, ${defaultFill} 0px, ${contrastFill} 40px, ${defaultFill} 80px)`
      : "none"
  };
}

const defaultHeroImages = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  height: [330, 450, 550, 750, 1000],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  maxHeight: { lg: "40vw" } as any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  minHeight: { lg: "32vw" } as any
};
export function heightAttrs(
  size: string | undefined
  // eslint-disable-next-line @typescript-eslint/ban-types
): Record<string, number[] | object> {
  switch (size) {
    case "category":
      return {
        height: [180, 250, 350, 450, 550]
      };
    case "hero":
      return {
        ...defaultHeroImages,
        maxWidth: "120rem" as any
      };
    case "followHero":
      return {
        ...defaultHeroImages
      };
    default:
      return {};
  }
}
